import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { EstadoPagare, PagareResumen } from 'app/models/pagare.model';
import { ConsultaExterno } from 'app/models/report.model';

@Injectable({
    providedIn: 'root'
})
export class ExternoService {

    private readonly APIurl = environment.apis + "/externo";
    constructor(
        private http: HttpClient
    ) {

    }

    getPagares(search: string, estado: number, fecha_inicial: string, fecha_final: string) {
        const headers = new HttpHeaders({
            'content-type': 'application/json; charset=utf-8',
        });
        let options = { headers: headers };

        let qs = {
            search: search != null ? encodeURIComponent(search) : '',
            estado: estado != 0 ? estado : '',
            fecha_inicial: fecha_inicial != null ? fecha_inicial : '',
            fecha_final: fecha_final != null ? fecha_final : '',
        };

        let qs2 = Object.keys(qs)
            .reduce(
                (acc, elem) => {
                    acc.push(elem + '=' + qs[elem]);
                    return acc;
                },
                ['?']
            )
            .join('&');
        return this.http.get<ConsultaExterno>(this.APIurl + '/pagares' + qs2, options);
    }

    getDocumento(folio: number) {
        // this.http refers to HttpClient. Note here that you cannot use the generic get<Blob> as it does not compile: instead you "choose" the appropriate API in this way.
        return this.http.get(this.APIurl + '/documento?folio=' + folio, { responseType: 'blob' });
    }

    listarEstadosPagare() {
        const headers = new HttpHeaders({
            'content-type': 'application/json; charset=utf-8',
        });
        let options = { headers: headers };
        return this.http.get<EstadoPagare[]>(this.APIurl + '/estado_pagare', options);
    }
}
